import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay, Virtual } from 'swiper/core';
import 'swiper/swiper-bundle.css';
import BytesTitle from '@components/local/bytes/BytesTitle';
import BytesCard from './BytesCard';
import { RiArrowRightSLine, RiArrowLeftSLine } from 'react-icons/ri';

SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);

const BytesArticles = ({ data, className }) => {
  return (
    <div className={className}>
      <BytesTitle
        title={'Top Articles to'}
        highlight={'Read'}
        href="/bytes/articles"
        description="Stay updated with data science and engineering trends and insights through our curated articles"
      />
      <section className="relative">
        <Swiper
          virtual
          slidesPerView={4}
          spaceBetween={40}
          breakpoints={{
            320: {
              slidesPerView: 1.2,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          navigation={{
            prevEl: '.article-prev',
            nextEl: '.article-next',
          }}
          pagination={{ clickable: true }}
          className="h-fit !pb-12 "
        >
          {' '}
          {data?.map((item, index) => (
            <SwiperSlide key={index}>
              <BytesCard articleCard titleOnly data={item} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="article-prev custom-prev-button flex h-full w-full items-center justify-center text-red">
          <RiArrowLeftSLine size={60} className="my-auto text-red" />
        </div>
        <div className="article-next custom-next-button flex h-full w-full items-center justify-center text-red">
          <RiArrowRightSLine size={60} className="my-auto text-red" />
        </div>
      </section>
    </div>
  );
};
export default BytesArticles;
